import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';

export default function McmCustomerForm() {
  return (
    <FormGroup>
      <FormHorizontal name="crossroads" label="Crossroads">
        <ZodFieldCheckbox name="crossroads" />
      </FormHorizontal>
      <FormHorizontal name="sothebys" label="Sothebys">
        <ZodFieldCheckbox name="sothebys" />
      </FormHorizontal>
    </FormGroup>
  );
}
